import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../../components/Logo";

const TABS = [
  { to: "/admin", label: "Overview", end: true, testid: "admin-tab-overview" },
  { to: "/admin/questions", label: "Questions", testid: "admin-tab-questions" },
  { to: "/admin/guides", label: "Revision Guides", testid: "admin-tab-guides" },
  { to: "/admin/reports", label: "Reports", testid: "admin-tab-reports" },
  { to: "/admin/comments", label: "Comments", testid: "admin-tab-comments" },
  { to: "/admin/users", label: "Users", testid: "admin-tab-users" },
  { to: "/admin/analytics", label: "Analytics", testid: "admin-tab-analytics" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-testid="admin-layout">
      <header className="border-b border-border bg-card sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Logo to="/admin" />
            <span className="text-xs font-bold tracking-[0.2em] uppercase bg-primary text-primary-foreground px-2.5 py-1 rounded">Admin CMS</span>
          </div>
          <button data-testid="admin-back-btn" onClick={() => navigate("/app")}
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to app
          </button>
        </div>
        <div className="max-w-7xl mx-auto px-6 flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  isActive ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
              {t.label}
            </NavLink>
          ))}
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
